<!-- Skeleton (full table placeholder - headers + body) -->
<vs-table-skeleton
  *ngIf="dataSource.firstLoad$ | async"
  [rows]="5"
  [columns]="columns?.length || 3"
  [columnDefs]="getSkeletonColumns()"
  [showHeader]="true"
  [banding]="true"
></vs-table-skeleton>

<!-- Actual Table (shown when data is loaded) -->
<ng-container *ngIf="(dataSource.firstLoad$ | async) === false">
  <vs-table
    *ngIf="
      (isListeningToRowClicked || forceClickableState === 'clickable') && forceClickableState !== 'not-clickable';
      else not_clickable
    "
    [columns]="$any(columns)"
    [data]="dataSource.items$ | async"
    [class.overflow-hidden]="preventTableScrolling$ | async"
    (rowClicked)="rowClicked.emit($event)"
  ></vs-table>

  <ng-template #not_clickable>
    <vs-table
      [columns]="$any(columns)"
      [data]="dataSource.items$ | async"
      [class.overflow-hidden]="preventTableScrolling$ | async"
    ></vs-table>
  </ng-template>
</ng-container>

<!-- Loading bar -->
<div *ngIf="cardContainer && (dataSource.loading$ | async)" class="absolute inset-0 bg-gray-50/25 z-20 overflow-hidden">
  <div class="relative w-full h-[3px] mt-[38px]">
    <div class="absolute inset-0 bg-primary-100"></div>
    <div id="indeterminate-progress-bar-value" class="absolute w-full h-full bg-primary-400"></div>
  </div>
</div>

<!-- Empty placeholder -->
<div
  *ngIf="(dataSource.isEmpty$ | async) && (dataSource.firstLoad$ | async) === false"
  class="bg-base-white w-full flex flex-col items-center justify-center py-10 px-8 gap-3"
>
  <vs-featured-icon name="search-lg" theme="default"></vs-featured-icon>
  <p class="text-gray-900 font-semibold">No items found</p>
  <ng-content select="[slot='empty']"></ng-content>
</div>

<!-- Error placeholder -->
<div
  *ngIf="dataSource.error$ | async as error"
  class="bg-base-white w-full flex flex-col items-center justify-center py-10 px-8 gap-3"
>
  <vs-featured-icon name="alert-circle" theme="warn"></vs-featured-icon>
  <div class="max-w-xs text-center">
    <p class="text-gray-900 font-semibold">Something went wrong...</p>
    <p class="text-gray-600 text-sm">
      We had some trouble loading this page. Please refresh the page to try again or get in touch if the problem sticks
      around!
    </p>
  </div>
  <ng-content select="[slot='error']"></ng-content>
</div>

<!-- Pagination -->
<ng-container *ngIf="paginationConfig$ | async as config">
  <vs-pagination
    *ngIf="config.totalItems > 0"
    theme="default"
    [config]="config"
    (currentPage)="dataSource.setPage($event)"
    (itemsPerPage)="dataSource.setLimit($event)"
  ></vs-pagination>
</ng-container>
